module.exports = __webpack_public_path__ + "753f1ed9ca612b4dfc839362353e7253.svg";